const paymentMethodsUrl = "v1/credit/billing/payments/methods";
export {
  paymentMethodsUrl
};
//# sourceMappingURL=endpoints.js.map
